import { Notifier } from '@airbrake/browser';
import { ENV } from '../constants';

const AIRBAKE_PROJECT_ID = 134194;
const AIRBAKE_PROJECT_KEY = '86258c0c7e793a90a074d87e6f911ef4';

let errorNotifier = null;

export const notify = ({ error, params }) => {
    if (errorNotifier !== null) {
        errorNotifier.notify({ error, params });
    }
};

export const startErrorNotifier = () => {

    if (ENV !== null) {
        // Start airbrake
        errorNotifier = new Notifier({
            projectId: AIRBAKE_PROJECT_ID,
            projectKey: AIRBAKE_PROJECT_KEY,
            environment: ENV,
        });
    }
};
